import React from "react";
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from "./Pages/Scroll To Top/ScrollToTop";
import NavbarCom from "./Components/Nav/Nav";
import Home from "./Pages/Home/Home";
import styled from "styled-components";
import Works from "./Pages/Works/Works";
import Blog from "./Pages/Blog/Blog";
import Contacts from "./Pages/Contacts/Contacts";
import Skills from "./Pages/Skills/Skills";
import About from "./Pages/About/About";
function App() {
    return (

        <NavbarStyle>
            <ScrollToTop/>
            <NavbarCom/>
            <Main>


                <Routes>

                    <Route path="/" element={<Home/>} />
                    <Route path="/works" element={<Works/>} />
                    <Route path="/about" element={<About/>} />
                    <Route path="/comparision" element={<Blog/>} />
                    <Route path="/skills" element={<Skills/>} />
                    <Route path="/contacts" element={<Contacts/>} />

                </Routes>
            </Main>
            {/*<Footer/>*/}
        </NavbarStyle>
    );
}

const NavbarStyle = styled.div`
`;
const Main = styled.div`
  margin-top: 20vh ;
`;


export default App;
